import { useTranslation } from "react-i18next";
import { cn } from "./lib/utils";

/**
 * Baked into the bundle rather than fetched: the sign-in screen is the one you are looking at
 * when the API is not answering, which is when the question gets asked. `dev` where there is no
 * build, because claiming a release number on a laptop is worse than admitting there is none.
 */
export function Version({ className }: { className?: string }) {
  const { t } = useTranslation();

  // Empty and absent are the same thing here. An unset build argument reaches the bundle as an
  // empty string rather than as undefined, and "Versie " with nothing after it is the one
  // outcome worse than admitting there is no build to name.
  const version = import.meta.env.VITE_APP_VERSION || "dev";
  const commit = import.meta.env.VITE_APP_COMMIT || null;

  return (
    <p
      className={cn("text-xs text-muted-foreground", className)}
      title={commit ? t("version.commit", { commit }) : undefined}
      data-testid="version"
    >
      {t("version.label", { version })}
    </p>
  );
}
